import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

/**
 * 定义 Cooperation 组件
 */
class Iframe extends React.PureComponent {
    render() {
        return (
            <div className={styles.iframeBox}>
                <iframe
                    className={styles.iframe}
                    src="https://www.wjx.cn/vm/eapOB8n.aspx?width=750&source=iframe&s=t"
                    width="100%"
                    height="1200"
                    frameBorder="0"
                    style={{ overflow: 'auto' }}
                />
            </div>
        );
    }
}

export default errorBoundary(Iframe);
